<style lang="scss" src='./AlertDetails.scss' scoped></style>
<template src="./AlertDetails.html"></template>

<script>
  import MapRedFlag from '@/assets/img/ic/ic_flag_red.png';
  import ApexChart from 'vue-apexcharts';
  import AlertChart from './components/chart/AlertChart';

  import {
    mapState
  } from 'vuex';
  export default {
    name: 'AlertDetails',
    components: {
      apexchart: ApexChart,
      AlertChart,
    },
    data() {
      return ({
        map: {},
        google: {},
        alertType: {},
        unitOfMeasurament: '',
      });
    },
    computed: {
      ...mapState('Dashboard', {
        alert: (state) => state.selectedAlert,
      }),
    },

    methods: {

      async initMap({
        lat = 0,
        lng = 0
      }) {
        const mapOptions = {
          mapId: 'map',
          zoom: 18,
          center: {
            lat,
            lng
          },
          controlOptions: {
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
          },
        };

        this.map = await this.G_initMap(mapOptions);
        this.google = this.consts.Google.MAP;

        const newMark = new window.google.maps.Marker({
          position: {
            lat,
            lng
          },
          icon: MapRedFlag,
        });
        
        if (this.map && this.google && this.google.maps) {
          newMark.setAnimation(this.google.maps.Animation.BOUNCE);
          newMark.setMap(this.map);

          // eslint-disable-next-line
          setTimeout(function () {
            newMark.setAnimation(null);
          }, 1500);
        }
      },
    },

    beforeCreate() {},

    created() {},

    mounted() {
      if (process.env.VUE_APP_SENTRY_ENV == "production") {
        this.$analytics.setCurrentScreen("Web Alerts Details");
        this.$analytics.logEvent("web_alerts_details");
      }

      if(this.alert && this.alert.sensor && this.alert.sensor.latitude && this.alert.sensor.latitude){
        if(this.G_validateLatLong(coordinates.latitude, coordinates.longitude)){
          this.initMap({
            lat: this.alert.sensor.latitude,
            lng: this.alert.sensor.longitude
          });
        }
      }
    },

    beforeDestroy() {},

  };

</script>
